import type { IsoDate, Lead } from '../../../../shared/types';
import { contractsExpiring } from '../../logic/dashboard';
import { section } from '../../ui/components';
import { h } from '../../ui/dom';
import { cardLink } from './cardLink';

/** Compact summary; Reports owns the contract bands and detail. */
export const contractsCard = (leads: readonly Lead[], today: IsoDate): HTMLElement => {
  const { total } = contractsExpiring(leads, today);
  return section({ title: 'Contracts expiring', action: cardLink('Reports', '#/dashboard') },
    h('p', { class: 'card__summary' }, `${total} contracts ending in the next 90 days`));
};
